/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostApiBookingParallelMutationRequest, PostApiBookingParallelMutationResponse, PostApiBookingParallelQueryParams } from "../entities/PostApiBookingParallel";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { postApiBookingParallel } from "../api/postApiBookingParallel";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const postApiBookingParallelMutationKey = () => [{ url: '/api/booking/parallel' }] as const

export type PostApiBookingParallelMutationKey = ReturnType<typeof postApiBookingParallelMutationKey>

export function postApiBookingParallelMutationOptions<TContext = unknown>(config: Partial<RequestConfig<PostApiBookingParallelMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = postApiBookingParallelMutationKey()
        return mutationOptions<PostApiBookingParallelMutationResponse, ResponseErrorConfig<Error>, {data: PostApiBookingParallelMutationRequest, params: PostApiBookingParallelQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ data, params }) => {
            return postApiBookingParallel(data, params, config)
          },
        })

}

/**
 * @description Создание параллельных записей для родителя и ребенка
 * @summary Создать параллельную запись
 * {@link /api/booking/parallel}
 */
export function usePostApiBookingParallel<TContext>(options: 
{
  mutation?: UseMutationOptions<PostApiBookingParallelMutationResponse, ResponseErrorConfig<Error>, {data: PostApiBookingParallelMutationRequest, params: PostApiBookingParallelQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<PostApiBookingParallelMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? postApiBookingParallelMutationKey()

          const baseOptions = postApiBookingParallelMutationOptions(config) as UseMutationOptions<PostApiBookingParallelMutationResponse, ResponseErrorConfig<Error>, {data: PostApiBookingParallelMutationRequest, params: PostApiBookingParallelQueryParams}, TContext>
          

          return useMutation<PostApiBookingParallelMutationResponse, ResponseErrorConfig<Error>, {data: PostApiBookingParallelMutationRequest, params: PostApiBookingParallelQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PostApiBookingParallelMutationResponse, ResponseErrorConfig<Error>, {data: PostApiBookingParallelMutationRequest, params: PostApiBookingParallelQueryParams}, TContext>
      
}